"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { useState } from "react";
import SkeletonCard from "@/components/common/skeleton/SkeletonCard";
const ChimneyCalculator = dynamic(() => import("@/components/chimney-calculator/chimney-calculator"), {
  ssr: false
});
interface ResourceCalculatorProps {
  guid: string;
  cssClass?: string;
}

/**
 * Client island for calculator articles: shows a skeleton until the embedded
 * ChimneyCalculator (client-only, ssr:false) reports it has loaded.
 */
const ResourceCalculator = t0 => {
  const $ = _c(12);
  const {
    guid,
    cssClass
  } = t0;
  const [calculatorLoaded, setCalculatorLoaded] = useState(false);
  let t1;
  if ($[0] !== calculatorLoaded) {
    t1 = !calculatorLoaded && <SkeletonCard className="h-[1280px] md:h-[800px]" />;
    $[0] = calculatorLoaded;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setCalculatorLoaded(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cssClass || $[4] !== guid) {
    t3 = <ChimneyCalculator className={cssClass} guid={guid} onLoad={t2} />;
    $[3] = cssClass;
    $[4] = guid;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className="min-h-[1280px] w-full md:min-h-[800px]">{t1}{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <hr className="my-[70px] hidden h-[1px] w-full border-0 bg-[#D9D8D6] md:block" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <>{t4}{t5}</>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default ResourceCalculator;